import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import * as logger from '../utils/logger';
import ErrorBlock from './ErrorBlock';

function isScrollable(element) {
  // try to change a scrollTop
  // if we can change it - element is scrollable
  // in some cases body has large scrollHeight but it is not scrollable

  const oldTop = element.scrollTop;
  element.scrollTop += 1;
  if (element.scrollTop !== oldTop) {
    element.scrollTop = oldTop;
    return true;
  }
  element.scrollTop -= 1;
  if (element.scrollTop !== oldTop) {
    element.scrollTop = oldTop;
    return true;
  }
  return false;
}

function getScrollParent(node) {
  if (node === null) {
    return null;
  }

  if (node.scrollHeight === 0 || node.clientHeight === 0) {
    return getScrollParent(node.parentNode);
  }

  const differentSizes = node.scrollHeight - node.clientHeight > 50;
  if (
    (differentSizes && isScrollable(node)) ||
    // stop on body
    (isScrollable(node) && node === document.body)
  ) {
    return node;
  } else {
    return getScrollParent(node.parentNode);
  }
}

class InfiniteScroll extends React.Component {
  static propTypes = {
    hasMore: PropTypes.bool.isRequired,
    initialLoad: PropTypes.bool,
    loadMore: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isLoadFailed: PropTypes.bool.isRequired,
    pageStart: PropTypes.number,
    threshold: PropTypes.number,
    items: PropTypes.array.isRequired,
    itemRender: PropTypes.func.isRequired,
    placeholderComponent: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.func
    ]).isRequired
  };

  static defaultProps = {
    pageStart: 1,
    threshold: 250
  };
  componentDidMount() {
    this.pageLoaded = this.props.pageStart;
    this.requestAttachListener();
    document.addEventListener('load', () => {
      // reattach
      this.detachScrollListener();
      this.attachScrollListener();
    });
    // set periodic check, because some external styles or js
    // may change things
    this.interval = setInterval(() => {
      this.detachScrollListener();
      this.attachScrollListener();
    }, 3000);
  }
  componentDidUpdate(oldProps) {
    // reset page loaded on category change
    if (oldProps.category !== this.props.category) {
      this.pageLoaded = 1;
    }
    // reattach to detect scrollable parent
    this.detachScrollListener();
    this.requestAttachListener();
  }
  componentWillUnmount() {
    this.detachScrollListener();
    clearInterval(this.interval);
  }

  requestAttachListener() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.attachScrollListener();
    }, 500);
  }
  attachScrollListener() {
    if (!this.props.hasMore) {
      return;
    }
    if (this.props.isLoading) {
      return;
    }
    if (this.props.isLoadFailed) {
      return;
    }
    this.scrollEl = getScrollParent(this.container);

    if (!this.scrollEl) {
      if (this.pageLoaded > 20) {
        const message = `Why we are loading so many pages?!? hasMore: ${
          this.props.hasMore
        }; isLoadFailed: ${this.props.isLoadFailed}; isLoading: ${
          this.props.isLoading
        }`;
        logger.error(new Error(message));
      }
      return this.props.loadMore((this.pageLoaded += 1));
    } else if (!this.scrollEl) {
      // TODO: load here again?
      return logger.error(new Error('Can not find scrollable parent'));
    }

    // if (this.scrollEl === document.body.parentNode) {
    window.addEventListener('scroll', this.scrollListener);
    // } else {
    this.scrollEl.addEventListener('scroll', this.scrollListener);
    // }
  }

  detachScrollListener() {
    clearTimeout(this.timeout);
    if (!this.scrollEl) {
      return;
    }
    // if (this.scrollEl === document.body.parentNode) {
    window.removeEventListener('scroll', this.scrollListener);
    // } else {
    this.scrollEl.removeEventListener('scroll', this.scrollListener);
    // }
  }

  scrollListener = _.throttle(() => {
    if (this.props.isLoading) {
      return;
    }

    const lastChild = _.last(this.container.childNodes);
    const box = lastChild.getBoundingClientRect();
    const offset = box.top - window.innerHeight;
    // console.log(lastChild);
    // const offset =
    //   this.scrollEl.scrollHeight -
    //   this.scrollEl.scrollTop -
    //   this.scrollEl.clientHeight;

    // console.log(offset);
    if (offset < Number(this.props.threshold)) {
      this.detachScrollListener();
      this.props.loadMore((this.pageLoaded += 1));
    }
  }, 50);

  handleTyAgainClick = () => {
    this.props.loadMore(this.pageLoaded);
  };

  render() {
    const PlaceholderComponent = this.props.placeholderComponent;
    return (
      <div
        ref={node => {
          this.container = node;
        }}
        className={this.props.isLoading ? 'animate-loader' : ''}
      >
        {!this.props.isLoading &&
        !this.props.isLoadFailed &&
        this.props.items.length === 0 ? (
          <div>No items...</div>
        ) : null}
        {this.props.items.map(el => this.props.itemRender(el))}
        {this.props.isLoading
          ? _.times(10, i => <PlaceholderComponent key={i} />)
          : null}
        {this.props.isLoadFailed ? (
          <ErrorBlock onTryAgain={this.handleTyAgainClick} />
        ) : null}
      </div>
    );
  }
}

export default InfiniteScroll;



// WEBPACK FOOTER //
// ./src/components/InfiniteScroll.js